import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { AddChecklistItemAction } from '../../actions/checklist-items/add-checklist-item-action';
import { GetChecklistItemsAction } from '../../actions/checklist-items/get-checklist-items-action';
import { AddChecklistItemErrorAction } from '../../actions/checklist-items/add-checklist-item-error-action';

@Injectable()
export class AddChecklistItemEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public AddChecklistItem = createEffect(() => this.actions
    .pipe(
      ofType(AddChecklistItemAction.type),
      mergeMap(action => {
        const addChecklistItemAction = <AddChecklistItemAction>action;
        return this.api.addChecklistItem(addChecklistItemAction.bijbEvent, addChecklistItemAction.checklistItem).then(() => {
          return new GetChecklistItemsAction(addChecklistItemAction.bijbEvent);
        }, error => {
          return new AddChecklistItemErrorAction(error);
        });
      })
    ));
}
